module.exports = __webpack_public_path__ + "img/ic_success.6afdbf09.png";